<script setup lang="ts">
const prop = {
  sizes: '80vw',
  media: {
    _type: 'media-asset',
    image: undefined,
    video: {
      asset: {
        assetId: 'gRRSZ5ULZZ0222PAiU3iTcvqdIvFzcQAfCzn2C2xpUFo',
        duration: 42.966667,
        filename: undefined,
        playbackId: 'b00EKPU9oEuDPIOdnDmEBX7BAa4Hp1SFfRNo02eWRChCs',
        thumbTime: null,
      },
    },
  },
  controls: undefined,
  loop: true,
  autoplay: true,
  muted: true,
}
</script>

<template>
  <CommonMedia v-bind="prop" />
</template>
